import React from 'react';
import {
  Form,
  TextFieldControl,
  ModalView,
  Stack,
} from '@piwikpro/ui-components';
import { FormValidator } from '@piwikpro/form-crate';
import { UserGroups } from '@piwikpro/user-groups-crate';
import { useTranslation } from 'react-i18next';
import { errorBoundary, withInject } from '@piwikpro/platform';

interface InjectedProps {
  userGroups: UserGroups
  validation: FormValidator
  Title: typeof React.Component
  filters: any
}

export interface CreateUserGroupProps extends InjectedProps {
  finish: (id: string) => void
  abort: () => void
}

const CreateUserGroup: React.FC<CreateUserGroupProps> = ({
  filters,
  finish,
  userGroups,
  abort,
  validation,
  Title,
}) => {
  const { t } = useTranslation(['administration', 'platform']);

  const handleSubmit = async (values, {
    setErrors,
    setSubmitting,
    setFieldValue,
  }) => {
    const name = values.name.trim();

    try {
      if (name.length > 0) {
        const response = await userGroups.create({ name });
        userGroups.find(filters);
        finish(response.data.id);
      } else {
        setSubmitting(false);
        setFieldValue('name', name, true);
      }
    } catch (err: any) {
      setErrors(err.errors);
      setSubmitting(false);
    }
  };


  return (
    <Title part={t('user-groups.create.title')} subset>
      <Form
        id="create-user-group-form"
        initialValues={{
          name: '',
        }}
        validationSchema={validation.createValidationSchema(validators => ({
          name: validators.userGroups.name,
        }))}
        onSubmit={handleSubmit}
      >
        <ModalView
          title={t('user-groups.create.group.title')}
          actions={(
            <Stack spacing="narrow" horizontalAlignment="right" verticalAlignment="center">
              <Form.Cancel onClick={abort} />
              <Form.Submit />
            </Stack>
          )}
        >
          <TextFieldControl
            name="name"
            autoFocus
            required
            label={t('user-groups.create.group.labels.name')}
          />
        </ModalView>
      </Form>
    </Title>
  );
};

export default withInject<InjectedProps>({
  validation: 'FormCrate.validation',
  userGroups: 'UserGroupsCrate.userGroups',
  Title: 'TitleCrate.components.Title',
})(errorBoundary(CreateUserGroup) as unknown as React.FC<CreateUserGroupProps>);
